import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { mockOrders } from '../../utils/mockData';
import { ArrowLeft, Printer } from 'lucide-react';
import { useToast } from '../../hooks/useToast';
export function PackingSlip() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const {
    showToast
  } = useToast();
  const order = mockOrders.find(o => o.id === id);
  if (!order) {
    return <div data-id="element-830">Order not found</div>;
  }
  const handlePrint = () => {
    showToast('Print dialog opened', 'info');
    // In a real app: window.print()
  };
  return <div className="min-h-screen bg-white" data-id="element-831">
      {/* Print Actions Bar */}
      <div className="bg-gray-50 border-b border-gray-200 px-6 py-4 print:hidden" data-id="element-832">
        <div className="max-w-4xl mx-auto flex items-center justify-between" data-id="element-833">
          <Button variant="outline" onClick={() => navigate(`/orders/${id}`)} data-id="element-834">
            <ArrowLeft className="h-4 w-4 mr-2" data-id="element-835" />
            Back to Order
          </Button>
          <Button onClick={handlePrint} data-id="element-836">
            <Printer className="h-4 w-4 mr-2" data-id="element-837" />
            Print
          </Button>
        </div>
      </div>

      {/* Packing Slip Content */}
      <div className="max-w-4xl mx-auto px-6 py-8" data-id="element-838">
        {/* Header */}
        <div className="mb-8" data-id="element-839">
          <div className="flex items-start justify-between mb-6" data-id="element-840">
            <div data-id="element-841">
              <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-842">
                Packing Slip
              </h1>
              <p className="text-gray-600" data-id="element-843">Order #{order.id}</p>
            </div>
            <div className="text-right" data-id="element-844">
              <p className="text-sm text-gray-600" data-id="element-845">Date</p>
              <p className="font-medium text-gray-900" data-id="element-846">
                {new Date(order.createdAt).toLocaleDateString()}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 mb-8" data-id="element-847">
            <div data-id="element-848">
              <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-849">Store</h3>
              <p className="font-medium text-gray-900" data-id="element-850">{order.storeName}</p>
            </div>
            <div data-id="element-851">
              <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-852">
                Customer
              </h3>
              <p className="font-medium text-gray-900" data-id="element-853">{order.customerName}</p>
              <p className="text-sm text-gray-600" data-id="element-854">{order.customerEmail}</p>
            </div>
          </div>

          {order.fulfillmentMethod === 'ship-to-home' && <div className="border-t border-gray-200 pt-6" data-id="element-855">
              <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-856">
                Ship To
              </h3>
              <div className="text-gray-900" data-id="element-857">
                <p className="font-medium" data-id="element-858">{order.customerName}</p>
                <p className="text-sm" data-id="element-859">123 Main Street</p>
                <p className="text-sm" data-id="element-860">Springfield, IL 62704</p>
              </div>
            </div>}
        </div>

        {/* Items Table */}
        <div className="border border-gray-200 rounded-lg overflow-hidden mb-8" data-id="element-861">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-862">
            <thead className="bg-gray-50" data-id="element-863">
              <tr data-id="element-864">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-865">
                  Product
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-866">
                  Size / Color
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-867">
                  Personalization
                </th>
                <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase" data-id="element-868">
                  Qty
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-869">
              <tr data-id="element-870">
                <td className="px-6 py-4 text-sm text-gray-900" data-id="element-871">
                  Performance T-Shirt
                </td>
                <td className="px-6 py-4 text-sm text-gray-600" data-id="element-872">
                  Adult L / Navy
                </td>
                <td className="px-6 py-4 text-sm text-gray-600" data-id="element-873">
                  <div data-id="element-874">Name: SMITH</div>
                  <div data-id="element-875">Number: 23</div>
                </td>
                <td className="px-6 py-4 text-sm text-gray-900 text-center" data-id="element-876">
                  2
                </td>
              </tr>
              <tr data-id="element-877">
                <td className="px-6 py-4 text-sm text-gray-900" data-id="element-878">Team Hoodie</td>
                <td className="px-6 py-4 text-sm text-gray-600" data-id="element-879">
                  Adult M / Gray
                </td>
                <td className="px-6 py-4 text-sm text-gray-600" data-id="element-880">—</td>
                <td className="px-6 py-4 text-sm text-gray-900 text-center" data-id="element-881">
                  1
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Notes Section */}
        <div className="border border-gray-200 rounded-lg p-6 mb-8" data-id="element-882">
          <h3 className="text-sm font-medium text-gray-900 mb-2" data-id="element-883">
            Special Instructions
          </h3>
          <p className="text-sm text-gray-600" data-id="element-884">
            No special instructions provided.
          </p>
        </div>

        {/* Barcode Placeholder */}
        <div className="flex justify-center" data-id="element-885">
          <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center" data-id="element-886">
            <div className="text-xs text-gray-500 mb-2" data-id="element-887">ORDER BARCODE</div>
            <div className="font-mono text-2xl font-bold text-gray-900" data-id="element-888">
              {order.id}
            </div>
          </div>
        </div>
      </div>
    </div>;
}